export default __webpack_public_path__ + "static/media/CHUBB.5e90b4f7.png";